import styled, { createGlobalStyle } from 'styled-components';

export const Disclaimer = styled.p`
  margin: 8px 0 16px;
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
`;

export const ApplyModeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  /* The shared Radio component centers its content (radio + label) horizontally via
     justify-content: center on a high-specificity "&&&" selector. Figma has these
     options left-aligned, so override it scoped to this section only. */
  .ant-radio-wrapper {
    justify-content: flex-start !important;
    width: 100%;
    gap: 15px;
  }
`;

export const ApplyModeOptionLabel = styled.span`
  display: block;
  margin: 0;
  color: var(--black-dark, #1a2535);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const ApplyModeOptionDescription = styled.span`
  display: block;
  margin: 0;
  color: var(--light-gray-darker, #57575c);
  font-family: var(--font-family-base), Lato, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const DefaultDeadlineModalGlobalStyles = createGlobalStyle`
  .default-deadline-modal .ant-modal {
    width: 595px !important;
    max-width: 595px;
  }

  .default-deadline-modal .ant-modal-content {
    border-radius: 20px;
    overflow: hidden;
    min-height: 480px;
    height: auto;
  }

  .default-deadline-modal .ant-modal-body > div > div:first-child {
    height: 112px;
    padding: 30px;
    justify-content: center;
    align-items: center;
  }

  .default-deadline-modal .ant-modal-body > div > div:nth-child(2) {
    padding: 40px 0 20px;
  }

  .default-deadline-modal .ant-modal-body > div > div:nth-child(3) {
    padding: 0 30px 30px;
    justify-content: flex-end;
  }

  .default-deadline-modal .ant-modal-close {
    top: 30px;
    right: 30px;
  }
`;
